import React, { useState, useEffect, useContext, useLayoutEffect } from "react"; // Agregado useContext
import { UserContext } from "../context/UserContext"; // Agregado UserContext
import { CartContext } from "../context/CartContext";
import OrderDetailModal from "../components/Modals/OrderLineItemsModal";
import { useHistory, useLocation } from "react-router-dom";
import FrequentProducts from "../components/FrequentProducts/FrequentProducts";
import { API_BASE } from "../utils/api";
import { isBMI, BMI_CUSTOMER_IDS } from "../utils/config";
import { hasAccountAccess } from "../utils/permissions";
import Unauthorized from "./Unauthorized"; // ajusta la ruta si es necesario
import { useLanguage } from "../context/LanguageContext";
import CustomerSearchModal from "../components/Modals/CustomerSearchModal";
import { duplicateOrder as duplicateOrderUtil } from "../utils/duplicateOrder";
import Ext1CustomerSelector from "../components/Modals/Ext1CustomerSelector";

export default function Dashboard() {
    const { t, switchLanguage, language } = useLanguage();
    // ✅ user seguro y sin recrearse en cada render
    const [currentUser, setCurrentUser] = useState(() =>
        JSON.parse(localStorage.getItem("user"))
    );
    const { updateSelectedCustomer, login } = useContext(UserContext);
    const { clearCart } = useContext(CartContext);
    const [lastOrders, setLastOrders] = useState([]);
    const [lastProformas, setLastProformas] = useState([]);
    const [pendingApproval, setPendingApproval] = useState([]);
    const [frequentProducts, setFrequentProducts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const history = useHistory();
    const location = useLocation();
    const isSupervisor = currentUser?.groupId === "     9";
    const isAdvisor = currentUser?.groupId === "     1";
    // El Aprobador aterriza directo en pendientes de aprobacion — no deberia
    // tener que ir a buscarlas al menu de Historial de Ordenes.
    const [activeTab, setActiveTab] = useState(
        location.state?.activeTab || (isSupervisor ? "pending_approval" : "pedidos")
    );
    const clase = "*";

    // =======================
    // Ext1: selector de cliente
    // =======================
    const [showExt1Selector, setShowExt1Selector] = useState(
        () => currentUser?.valorExt1 > -1 && !currentUser?.idCustomer
    );

    const handleExt1Select = (fullCustomer) => {
        const updatedUser = {
            ...currentUser,
            _customerSwitched: true,
            idCustomer: fullCustomer.idCustomer,
            customerId: fullCustomer.customerId,
            companyName: fullCustomer.companyName,
            nameShipTo: fullCustomer.shipToName,
            address: fullCustomer.address,
            city: fullCustomer.city,
            cedula: fullCustomer.cedula,
            idShipTo: fullCustomer.idShipTo || null,
            addressShipTo: fullCustomer.addressShipTo,
            cityShipTo: fullCustomer.cityShipTo,
            priceType: fullCustomer.priceType,
            creditTermId: fullCustomer.creditTermId,
            creditTerms: fullCustomer.creditTerms,
            infoDelivery: fullCustomer.infoDelivery,
            phone: fullCustomer.phone,
            phoneShipTo: fullCustomer.phoneShipTo,
            bodegaId: fullCustomer.bodegaId ?? currentUser?.bodegaId,
            bodegaName: fullCustomer.bodegaName ?? currentUser?.bodegaName,
        };
        login(updatedUser);
        clearCart();
        localStorage.removeItem("order_express_items");
        localStorage.removeItem("checkout_payload");
        sessionStorage.removeItem("frequent_products_page");
        setCurrentUser(updatedUser);
        setShowExt1Selector(false);
    };

    // =======================
    // Cargar datos al entrar
    // =======================
    useEffect(() => {
        if (!currentUser) return;

        loadLastOrders();
        loadLastProformas();
        if (isSupervisor || isAdvisor) loadPendingApproval();
    }, [currentUser]); // Se dispara si el currentUser cambia (ej: tras seleccionar cliente)

    // =======================
    // 1) Últimos pedidos
    // =======================
    const loadLastOrders = async () => {
        try {

            const url = `${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce` +
                `?id_customer=${currentUser.idCustomer}` +
                `&id_ship_to=${currentUser.idShipTo}` +
                `&clase=${clase}` +
                `&tipo=PE` +
                `&tipo2=null` +
                `&top=5`;

            const response = await fetch(url, { cache: "no-store" });
            const data = await response.json();

            const finalData = data.slice(0, 5);

            setLastOrders(finalData);

        } catch (err) {
            console.error("Error cargando últimos ordenes", err);
        }
    };


    // =======================
    // 2) Últimas proformas
    // =======================
    const loadLastProformas = async () => {
        try {
            const url = `${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce` +
                `?id_customer=${currentUser.idCustomer}` +
                `&id_ship_to=${currentUser.idShipTo}` +
                `&clase=` +
                `&tipo=PE` +
                `&tipo2=null` +
                `&top=5`;

            const response = await fetch(url, { cache: "no-store" });
            const data = await response.json();
            setLastProformas(data.slice(0, 5));
        } catch (err) {
            console.error("Error cargando últimas proformas", err);
        }
    };

    // =======================
    // 3) Pendientes de aprobación (solo Aprobador)
    // =======================
    const loadPendingApproval = async () => {
        try {
            const buildParams = (idCustomer) => {
                const params = new URLSearchParams();
                params.append("id_customer", idCustomer);
                // El Aprobador siempre ve TODAS las sucursales aqui (no se manda
                // id_ship_to, el backend lo recibe NULL), sin importar en que sucursal
                // haya quedado parada su sesion — no puede cambiar de sucursal, se le
                // muestra todo de una. El Asesor si respeta su sucursal actual.
                if (!isSupervisor && Number(currentUser.idShipTo)) {
                    params.append("id_ship_to", Number(currentUser.idShipTo));
                }
                params.append("myaccount_id", currentUser.myaccountId);
                params.append("clase", "+");
                params.append("tipo", "PE");
                return params;
            };

            // El Aprobador de una marca BMI ve pendientes de ambas cuentas (UIO+GYE),
            // no solo la de su propia sesion — son la misma marca para efectos de
            // aprobacion, igual que en Mantenimiento de Presupuestos.
            const idCustomers = isSupervisor && isBMI(currentUser) ? BMI_CUSTOMER_IDS : [currentUser.idCustomer];

            const results = await Promise.all(
                idCustomers.map((idCustomer) =>
                    fetch(`${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce?${buildParams(idCustomer).toString()}`, { cache: "no-store" })
                        .then((r) => r.json())
                        .then((d) => (Array.isArray(d) ? d : []))
                )
            );
            // Ordenar por fecha antes de recortar a 5 — si no, al juntar ambas
            // cuentas BMI se quedaria solo con las de la primera (UIO) cuando ya
            // tiene 5 o mas, sin llegar nunca a mostrar las de GYE.
            const merged = results
                .flat()
                .sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate));
            setPendingApproval(merged.slice(0, 5));
        } catch (err) {
            console.error("Error cargando pendientes de aprobación", err);
        }
    };

    // =======================
    // Duplicar pedido
    // =======================
    const duplicateOrder = (order, items) => duplicateOrderUtil(order, items, { history });


    // =======================
    // Productos frecuentes (temporal)
    // =======================
    const loadFrequentProducts = async () => {
        setFrequentProducts([]);
    };

    if (!currentUser)
        return (
            <div className="mt-20 text-center text-gray-600">
                Cargando...
            </div>
        );
    // ✅ ESTA LÍNEA ES OBLIGATORIA
    const hasAccess = hasAccountAccess();
    // ✅ render condicional DESPUÉS de hooks
    if (!hasAccess) {
        return <Unauthorized />;
    }

    return (
        <div className="container mx-auto px-4 py-5 mt-[100px] md:mt-[180px] lg:mt-[100px]">
            <Ext1CustomerSelector
                open={showExt1Selector}
                onSelect={handleExt1Select}
                onClose={() => setShowExt1Selector(false)}
            />
            <CustomerSearchModal
                open={isModalOpen}
                onSelect={updateSelectedCustomer}
                onClose={() => setIsModalOpen(false)}
            />
            {/* BREADCRUMB */}
            <div className="text-sm text-gray-500 mb-0 hidden">
                Home <span className="mx-1">{">"}</span> Dashboard
            </div>

            {/* TÍTULO */}
            <h1 className="text-3xl font-bold text-brand-primary mb-2 -mt-10">
                {t.dashboardTitle}
            </h1>

            {/* ====================== */}
            {/* TABS: Pedidos / Proformas */}
            {/* ====================== */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">

            {/* TAB BUTTONS */}
            <div className="flex gap-0 mt-2 mb-0 border-b border-gray-300">
                <button
                    onClick={() => setActiveTab("pedidos")}
                    className={`px-5 py-2 text-sm font-semibold transition border-b-2 -mb-px ${
                        activeTab === "pedidos"
                            ? "border-brand-primary text-brand-primary"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                    }`}
                >
                    {t.dashboardSubtitle || "Últimos Pedidos"}
                </button>
                {currentUser.swWeb19 === true && (
                    <button
                        onClick={() => setActiveTab("proformas")}
                        className={`px-5 py-2 text-sm font-semibold transition border-b-2 -mb-px ${
                            activeTab === "proformas"
                                ? "border-brand-primary text-brand-primary"
                                : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        últimas Proformas
                    </button>
                )}
                {(isSupervisor || isAdvisor) && (
                    <button
                        onClick={() => setActiveTab("pending_approval")}
                        className={`px-5 py-2 text-sm font-semibold transition border-b-2 -mb-px flex items-center gap-2 ${
                            activeTab === "pending_approval"
                                ? "border-brand-primary text-brand-primary"
                                : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        Pendientes de aprobación
                        {pendingApproval.length > 0 && (
                            <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-bold bg-brand-primary text-white">
                                {pendingApproval.length}
                            </span>
                        )}
                    </button>
                )}
            </div>

            {/* TAB CONTENT */}
            <div className="space-y-2 max-h-[500px] overflow-y-auto pr-2 mt-4">

                {/* ENCABEZADOS */}
                <div className="hidden md:grid grid-cols-8 px-4 py-3 bg-gray-100 border-b border-gray-300 text-gray-700 font-semibold text-sm sticky top-0 z-20">
                    {activeTab === "pending_approval" && <span>Sucursal</span>}
                    <span>Usuario</span>
                    <span>Fecha</span>
                    <span>{activeTab === "pedidos" ? "Orden Nro" : "Número"}</span>
                    <span>Orden de Compra</span>
                    <span className="text-right">Total</span>
                    {activeTab !== "pending_approval" && (
                        <span className={`text-center${activeTab === "proformas" ? " col-span-2" : ""}`}>Estado</span>
                    )}
                    {activeTab === "pedidos" && <span></span>}
                </div>

                {/* PEDIDOS */}
                {activeTab === "pedidos" && (
                    <>
                        {lastOrders.length === 0 && (
                            <p className="text-gray-500">No tienes ordenes registrados...</p>
                        )}
                        {lastOrders.map((o, index) => (
                            <div
                                key={o.orderId}
                                onClick={() => history.push(`/order-details/${o.orderId}`, { order: o })}
                                className="
                                    bg-white border border-gray-200 rounded-lg p-3 shadow-sm
                                    grid grid-cols-1 md:grid-cols-8
                                    gap-2 items-center
                                    hover:bg-gray-200 hover:shadow-lg transition
                                    cursor-pointer
                                "
                            >
                                <div className="flex items-center gap-3">
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-gray-200 text-gray-700 text-[11px] font-bold">
                                        {index + 1}
                                    </span>
                                    <span className={`text-sm ${o.branchId?.trim() === 'e' ? 'text-brand-primary' : 'text-gray-700'}`}>
                                        {o.employeeId}
                                    </span>
                                </div>
                                <div className="text-gray-700 text-sm">
                                    {new Date(o.orderDate).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })}
                                </div>
                                <div className="text-gray-800 font-semibold text-sm">{o.orderNumber}</div>
                                <div className="text-gray-800 font-semibold text-sm">{o.invoiceNumber ?? "—"}</div>
                                <div className="text-ultra-red text-right font-bold text-sm">${Number(o.total || 0).toFixed(2)}</div>
                                <span className="inline-block px-2 py-1 text-[11px] font-semibold rounded-md text-center text-black-700">
                                    {o.clase === "+" ? "PENDIENTE DE APROBACIÓN" : o.status}
                                </span>
                            </div>
                        ))}
                    </>
                )}

                {/* PROFORMAS */}
                {activeTab === "proformas" && (
                    <>
                        {lastProformas.length === 0 && (
                            <p className="text-gray-500">No tienes proformas registradas...</p>
                        )}
                        {lastProformas.map((o, index) => (
                            <div
                                key={o.orderId}
                                onClick={() => history.push(`/order-details/${o.orderId}`, { order: o })}
                                className="
                                    bg-white border border-gray-200 rounded-lg p-3 shadow-sm
                                    grid grid-cols-1 md:grid-cols-8
                                    gap-2 items-center
                                    hover:bg-gray-200 hover:shadow-lg transition
                                    cursor-pointer
                                "
                            >
                                <div className="flex items-center gap-3">
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-gray-200 text-gray-700 text-[11px] font-bold">
                                        {index + 1}
                                    </span>
                                    <span className={`text-sm ${o.branchId?.trim() === 'e' ? 'text-brand-primary' : 'text-gray-700'}`}>
                                        {o.employeeId}
                                    </span>
                                </div>
                                <div className="text-gray-700 text-sm">
                                    {new Date(o.orderDate).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })}
                                </div>
                                <div className="text-gray-800 font-semibold text-sm">{o.orderNumber}</div>
                                <div className="text-gray-800 font-semibold text-sm">{o.invoiceNumber ?? "—"}</div>
                                <div className="text-ultra-red text-right font-bold text-sm">${Number(o.total || 0).toFixed(2)}</div>
                                <span className="col-span-2 inline-block px-2 py-1 text-[11px] font-semibold rounded-md text-center text-black-700">
                                    {o.status}
                                </span>
                            </div>
                        ))}
                    </>
                )}

                {/* PENDIENTES DE APROBACIÓN */}
                {activeTab === "pending_approval" && (
                    <>
                        {pendingApproval.length === 0 && (
                            <p className="text-gray-500">No tienes órdenes pendientes de aprobación.</p>
                        )}
                        {pendingApproval.map((o, index) => (
                            <div
                                key={o.orderId}
                                onClick={() => history.push(`/order-details/${o.orderId}`, { order: o })}
                                className="
                                    bg-white border border-gray-200 rounded-lg p-3 shadow-sm
                                    grid grid-cols-1 md:grid-cols-8
                                    gap-2 items-center
                                    hover:bg-gray-200 hover:shadow-lg transition
                                    cursor-pointer
                                "
                            >
                                <div className="text-gray-700 text-sm">
                                    {o.shipToName || "MATRIZ"}
                                </div>
                                <div className="flex items-center gap-3">
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-gray-200 text-gray-700 text-[11px] font-bold">
                                        {index + 1}
                                    </span>
                                    <span className={`text-sm ${o.branchId?.trim() === 'e' ? 'text-brand-primary' : 'text-gray-700'}`}>
                                        {o.employeeId}
                                    </span>
                                </div>
                                <div className="text-gray-700 text-sm">
                                    {new Date(o.orderDate).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })}
                                </div>
                                <div className="text-gray-800 font-semibold text-sm">{o.orderNumber}</div>
                                <div className="text-gray-800 font-semibold text-sm">{o.invoiceNumber ?? "—"}</div>
                                <div className="text-ultra-red text-right font-bold text-sm">${Number(o.total || 0).toFixed(2)}</div>
                            </div>
                        ))}
                    </>
                )}
            </div>
            </div>

            {/* FREQUENTLY ORDERED PRODUCTS */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 mt-4">
                <FrequentProducts
                    idCustomer={currentUser.idCustomer}
                    idShipTo={currentUser.idShipTo == null ? 0 : currentUser.idShipTo}
                    t={t}
                />
            </div>

            <OrderDetailModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                order={selectedOrder}
                onDuplicate={duplicateOrder}
            />
        </div>
    );
}
